<template>
	<b-col cols="12" sm="6" lg="3" class="text-center">
		<div
			v-animate-onscroll="animateClass"
			ref="teamItem"
			class="team-item mt-5"
			@click="flipItem"
			@mouseleave="flipItemBack"
		>
			<div ref="teamItemFlipper" class="flipper">
				<div class="flipper-side -front">
					<div ref="teamItemCard" class="card">
						<b-embed v-if="isVideo" ref="teamItemCardVideo" type="video" aspect="16by9" playsinline loop>
							<source :src="cardVideoMp4" type="video/mp4" />
							<source :src="cardVideoWebm" type="video/webm" />
						</b-embed>
						<b-img
							v-else-if="isImage"
							ref="teamItemCardImage"
							:src="cardImage"
							class="card-img-top"
						></b-img>
						<div ref="teamItemCardBody" class="card-body">
							<span class="badge-box">
								<span class="icon">
									<FAIcon icon="user-circle" size="lg" />
								</span>
							</span>
							<h4 class="card-title">{{ itemData.info.name }}</h4>
							<h6 class="card-subtitle mb-2">{{ itemData.info.position }}</h6>
							<p class="card-text">{{ itemData.info.intro }}</p>
							<p class="small mb-0">Saber más</p>
						</div>
					</div>
				</div>
				<div v-if="true" class="flipper-side -back">
					<div class="card">
						<div class="card-body">
							<p class="card-text">{{ itemData.info.description }}</p>
							<span v-if="hasSocial" class="social-box">
								<a v-if="hasEmail" :href="'mailto:' + itemData.social.email">
									<FAIcon icon="envelope" />
								</a>
								<a v-if="hasFacebook" :href="itemData.social.facebook">
									<FAIcon :icon="['fab', 'facebook-f']" />
								</a>
								<a v-if="hasInstagram" :href="itemData.social.instagram">
									<FAIcon :icon="['fab', 'instagram']" />
								</a>
								<a v-if="hasTwitter" :href="itemData.social.twitter">
									<FAIcon :icon="['fab', 'twitter']" />
								</a>
								<a v-if="hasLinkedin" :href="itemData.social.linkedin">
									<FAIcon :icon="['fab', 'linkedin']" />
								</a>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-col>
</template>

<script>
export default {
	name: 'TeamItem',

	props: {
		itemData: {
			type: Object,
			required: true
		}
	},

	computed: {
		isImage() {
			return this.itemData.media_type == 'image'
		},
		isVideo() {
			return this.itemData.media_type == 'video'
		},
		cardImage() {
			return this.isImage ? require('@/assets/media/team/' + this.itemData.media.file) : null
		},
		cardVideoMp4() {
			return this.isVideo ? require('@/assets/media/team/' + this.itemData.media.file_mp4) : null
		},
		cardVideoWebm() {
			return this.isVideo ? require('@/assets/media/team/' + this.itemData.media.file_webm) : null
		},
		hasEmail() {
			return this.itemData.social.email
		},
		hasFacebook() {
			return this.itemData.social.facebook
		},
		hasInstagram() {
			return this.itemData.social.instagram
		},
		hasTwitter() {
			return this.itemData.social.twitter
		},
		hasLinkedin() {
			return this.itemData.social.linkedin
		},
		hasSocial() {
			return this.hasEmail || this.hasFacebook || this.hasInstagram || this.hasTwitter || this.hasLinkedin
		},
		animateClass() {
			let animateClass = 'animate__animated '

			if (this.itemData.isFirst) {
				animateClass += 'animate__fadeInLeft'
			} else if (this.itemData.isLast) {
				animateClass += 'animate__fadeInRight'
			} else {
				animateClass += 'animate__fadeInUp'
			}

			return animateClass
		}
	},

	mounted() {
		this.getItemHeight().then(itemHeight => {
			this.setCardHeight(itemHeight)
		})

		if (this.isVideo) {
			this.autoPlayVideo()
		}
	},

	methods: {
		getItemHeight() {
			let itemMediaHeight

			if (this.itemData.media_type == 'video') {
				itemMediaHeight = this.$refs.teamItemCardVideo.clientHeight
			} else if (this.itemData.media_type == 'image') {
				itemMediaHeight =
					(this.$refs.teamItemCardImage.naturalHeight * this.$refs.teamItemCard.clientWidth) /
					this.$refs.teamItemCardImage.naturalWidth
			} else {
				itemMediaHeight = 0
			}

			let itemHeight = itemMediaHeight + this.$refs.teamItemCardBody.clientHeight

			return new Promise((resolve, reject) => {
				if (itemHeight) {
					resolve(itemHeight)
				} else {
					reject(new Error('Fails getting Item Height!'))
				}
			})
		},
		setCardHeight(itemHeight) {
			let teamItem = this.$refs.teamItem

			teamItem.style.height = itemHeight + 'px'
		},

		flipItem() {
			const flipper = this.$refs.teamItemFlipper

			flipper.classList.toggle('flipped')
		},
		flipItemBack() {
			const flipper = this.$refs.teamItemFlipper

			if (flipper.classList.contains('flipped')) {
				flipper.classList.toggle('flipped')
			}
		},
		autoPlayVideo() {
			let video = this.$refs.teamItemCardVideo.children[0]
			video.muted = true
			video.play()
		}
	}
}
</script>
